import { NgModule } from '@angular/core';
import { mapToCanActivate, RouterModule, Routes } from '@angular/router';
import { LoginGuard } from './guards/login.guard';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: 'login',
    pathMatch: 'full',
    canActivate: mapToCanActivate([LoginGuard]),
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'invoice',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./invoice-list/invoice-list.module').then(
        (m) => m.InvoiceListModule,
      ),
  },
  {
    path: 'extract-report',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./extract-report/extract-report.module').then(
        (m) => m.ExtractReportModule,
      ),
  },
  {
    path: 'user-management',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./user-management/user-management.module').then(
        (m) => m.UserManagementModule,
      ),
  },
  {
    path: 'activity-logs',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./activity-logs/activity-logs.module').then(
        (m) => m.ActivityLogsModule,
      ),
  },
  {
    path: 'voucher-dashboard',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./voucher-portal/voucher-dashboard/voucher-dashboard.module').then(
        (m) => m.VoucherDashboardModule,
      ),
  },
  {
    path: 'create-voucher',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./voucher-portal/create-voucher/create-voucher.module').then(
        (m) => m.CreateVoucherModule,
      ),
  },
  {
    path: 'create-voucher/:id/:status/:active',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./voucher-portal/create-voucher/create-voucher.module').then(
        (m) => m.CreateVoucherModule,
      ),
  },
  {
    path: 'create-voucher/:id/:status/:active/:campaignId',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./voucher-portal/create-voucher/create-voucher.module').then(
        (m) => m.CreateVoucherModule,
      ),
  },
  {
    path: 'create-merchant',
    //canActivate: [AuthGuard],
    loadChildren: () =>
      import('./voucher-portal/merchant/merchant.module').then(
        (m) => m.MerchantModule,
      ),
  },
  {
    path: 'create-campaign',
    // canActivate: [AuthGuard],
    loadChildren: () =>
      import('./voucher-portal/campaign/campaign.module').then(
        (m) => m.CampaignModule,
      ),
  },
  {
    path: 'create-sales-combination',
    // canActivate: [AuthGuard],
    loadChildren: () =>
      import('./voucher-portal/sales-combination/sales-combination.module').then(
        (m) => m.SalesCombinationModule,
      ),
  },
  {
    path: 'create-sales-combination/bundle-packages/:id/:status',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./voucher-portal/sales-combination/sales-combination.module').then(
        (m) => m.SalesCombinationModule,
      ),
  },
  {
    path: 'upload-images',
    // canActivate: [AuthGuard],
    loadChildren: () =>
      import('./voucher-portal/upload-images/upload-images.module').then(
        (m) => m.UploadImagesModule,
      ),
  },
  {
    path: 'transactions',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./voucher-portal/transactions/transactions.module').then(
        (m) => m.TransactionsModule,
      ),
  },
  {
    path: 'search-voucher',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./voucher-portal/search-update/search-voucher/search-voucher.module').then(
        (m) => m.SearchVoucherModule,
      ),
  },
  {
    path: 'search-merchant',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./voucher-portal/search-update/search-merchant/search-merchant.module').then(
        (m) => m.SearchMerchantModule,
      ),
  },
  {
    path: 'search-campaign',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./voucher-portal/search-update/search-campaign/search-campaign.module').then(
        (m) => m.SearchCampaignModule,
      ),
  },
  {
    path: 'update-merchant/:id',
    //canActivate: [AuthGuard],
    loadChildren: () =>
      import('./voucher-portal/merchant/merchant.module').then(
        (m) => m.MerchantModule,
      ),
  },
  {
    path: 'update-campaign/:id',
    // canActivate: [AuthGuard],
    loadChildren: () =>
      import('./voucher-portal/campaign/campaign.module').then(
        (m) => m.CampaignModule,
      ),
  },
  {
    path: 'search-sales-combination',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./voucher-portal/search-update/search-sales-combination/search-sales-combination.module').then(
        (m) => m.SearchSalesCombinationModule,
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    canActivate: [AuthGuard],
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
    // redirectTo: 'invoice',
    // pathMatch: 'full',
  },
  {
    path: '*',
    pathMatch: 'full',
    canActivate: [AuthGuard],
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
    // redirectTo: 'invoice',
    // pathMatch: 'full',
  },
  {
    path: 'error-management',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./error-management/error-management.module').then(
        (m) => m.ErrorManagementModule,
      ),
  },
  //TASK 45895 Add Sorting Priority to Campaigns Banners
  {
    path: 'catalogue-overrides',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./catalogue-overrides/catalogue-overrides.module').then(
        (m) => m.CatalogueOverridesModule,
      ),
  },
  {
    path: 'market',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./service-market/service-market.module').then(
        (m) => m.ServiceMarketModule,
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      { useHash: true },
      //   { enableTracing: true } // <-- debugging purposes only
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
